import React from 'react';
import FileUploadButton from '../../UI/FileUploadButton/index';
import styles from './styles.scss';
import { Button } from '../../UI/index';
import { IDownload } from '../files.interface';

export const Upload = ({
  id,
  uploadLink,
  onFileProgress,
  onFileComplete,
  onFileError,
  themeColor = 'blue',
}: IDownload) => (
  <div className={styles.upload_wrapper}>
    <FileUploadButton
      id={`${id}`}
      uploadLink={uploadLink}
      onFileProgress={onFileProgress}
      onFileComplete={onFileComplete}
      onFileError={onFileError}
    >
      <Button color={themeColor} style={{ display: 'flex', alignItems: 'center', color: themeColor }}>
        <div
          className={styles.upload}
          style={{
            color: themeColor === 'blue' ? '#2787F5' : 'green',
          }}
        >
          +
        </div>
        <span className={styles.upload_text}>Загрузить документ</span>
      </Button>
    </FileUploadButton>
  </div>
);
